import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentBack = styled.div`
  margin-left: 2%;
  padding: 2em 0;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  width: 96%;
  margin-bottom: 2%;
  button {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
    font-size: 14px;
    font-weight: 500;
    border: none;
    box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
    border-radius: 5px;
    width: 4%;
    height: 25px;
    margin: 0px 8px 0 0;
    text-align: left;
    svg {
      font-size: 17px;
    }
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;
